import { render, staticRenderFns } from "./ListMedicament.vue?vue&type=template&id=0f4ed1ec&lang=true"
import script from "./ListMedicament.vue?vue&type=script&lang=js"
export * from "./ListMedicament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports